import { MoreHorizontal } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { TOOL_IMAGE_PREVIEW_LIMIT, parseToolImagePreviewOutput, getTrustedToolMediaUrl } from '@arthelper/shared';

export function ToolImagePreviewStrip({ output }: { output: unknown }) {
  const { t } = useTranslation('chat');
  const { images, hasMore } = parseToolImagePreviewOutput(output);
  const previewImages = images.slice(0, TOOL_IMAGE_PREVIEW_LIMIT);

  if (previewImages.length === 0) {
    return <p className="text-xs font-light text-gray-400">{t('tool.search-images.no-results')}</p>;
  }

  return (
    <div className="flex flex-wrap items-center gap-1 text-xs font-light text-gray-400">
      {previewImages.map((image, index) => {
        const key = String(image.id ?? index);
        const src =
          getTrustedToolMediaUrl(image.thumbnailUrl) ?? getTrustedToolMediaUrl(image.optimizedUrl) ?? undefined;
        const alt =
          typeof image.title === 'string' && image.title.trim()
            ? image.title
            : t('tool.image-preview.image-alt', { id: key });

        if (!src) {
          return (
            <div
              key={key}
              className="flex h-10 w-10 shrink-0 items-center justify-center rounded bg-gray-100 text-gray-300"
              aria-hidden
            />
          );
        }

        return <img key={key} src={src} alt={alt} className="h-10 w-10 shrink-0 rounded object-cover" loading="lazy" />;
      })}
      {hasMore ? (
        <div
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded bg-gray-100 text-gray-400"
          aria-label={t('tool.image-preview.more-images')}
        >
          <MoreHorizontal className="h-4 w-4" aria-hidden />
        </div>
      ) : null}
    </div>
  );
}
